import * as t from "io-ts"

export const TCountry = t.interface({
  code: t.string,
  name: t.string
})

export const TCountries = t.array(TCountry)

export type Country = t.TypeOf<typeof TCountry>
export type Countries = t.TypeOf<typeof TCountries>
